import React from 'react'
import { useNavigate } from 'react-router-dom'

const WelcomeKitSection = ({ data }) => {
  const navigate = useNavigate()
  const image = data?.image
  const clickable = data?.clickable
  const navigation = data?.navigation

  const handleImageClick = () => {
    if (clickable) {
      navigate('welcome-kit', { state: { navMetaData: navigation?.metaData } })
    }
  }
  return (
    <section className="w-full bg-white -mt-5">
      <div className="max-w-[1024px] mx-auto px-2">
        <div className="items-center">
          <img
            src={image}
            alt="Welcome kit"
            className="w-full mx-auto object-scale-down"
            onClick={handleImageClick}
          />
        </div>
      </div>
    </section>
  )
}

export default WelcomeKitSection
